import React from 'react';
import { Button } from 'gatorcomponents';
import { isBRServer } from '@/utils/Validators/validation';
import * as Styles from './PerformanceBanner.styles';
import imageBR from './media/upgrade-performance-br.png';
import imageES from './media/upgrade-performance-es.png';
import { DEDICATED_LINUX_SERVER_URL } from '@/config/urls/dedicatedLinuxServerUrls';

const PerformanceBanner = ({ locale }) => {
  if (!locale) return null;

  const onLearnMore = () => {
    window.open(DEDICATED_LINUX_SERVER_URL, '_blank');
  };

  return (
    <Styles.Banner data-testid="vpsoci-upgrade-performance-banner">
      <Styles.Content>
        <Styles.Title data-testid="vpsoci-upgrade-performance-banner-title">
          {locale.title}
        </Styles.Title>
        <Styles.Description data-testid="vpsoci-upgrade-performance-banner-description">
          {locale.descriptionPrefix}
          <Styles.DescriptionBold>{locale.descriptionBold}</Styles.DescriptionBold>
          {locale.descriptionSuffix}
        </Styles.Description>
        <Button
          label={locale.button}
          variant="secondary"
          size="medium2"
          version="v2"
          width="fit-content"
          onClick={onLearnMore}
          testId="vpsoci-upgrade-performance-banner-button"
        />
      </Styles.Content>

      <Styles.ImageWrapper aria-hidden="true">
        <Styles.BannerImage src={isBRServer ? imageBR : imageES} alt="" />
      </Styles.ImageWrapper>
    </Styles.Banner>
  );
};

export default PerformanceBanner;
